import { RefreshTimes } from "@audacy-clients/core/atoms/helpers/constants";
import { wrapEpisodeList } from "@audacy-clients/core/atoms/wrappers/episode";
import { type IEpisode } from "@audacy-clients/core/atoms/wrappers/types";
import clientServices from '@audacy-clients/core/utils/clientServices';
import { isValidEpisodeOrFiller } from "@audacy-clients/core/utils/episode";
import { useQuery } from "@tanstack/react-query";


export type TLiveNowParams = {
  contentId?: string;
  isStation?: boolean;
};

type TLiveEpisodeQueryState = {
  liveEpisode?: IEpisode | null;
  isLoading: boolean;
}

async function fetchLiveEpisode({ contentId, isStation }: TLiveNowParams): Promise<IEpisode | null> {
  if (!contentId) {
    return null;
  }

  const data = isStation
    ? await clientServices.getDataServices().getSchedules(contentId)
    : await clientServices.getDataServices().getCurrentEpisodes(contentId)

  const episodes = wrapEpisodeList(data).getAll()
  if (!episodes || episodes.length <= 1) {
    return null
  }

  const now = Date.now()
  return episodes.find(
    e => now > e.startTime && now < e.endTime && isValidEpisodeOrFiller(e) && !e.isOnAirOnly
  ) ?? null
}

export function useLiveEpisodeFromSchedule({ contentId, isStation }: TLiveNowParams): TLiveEpisodeQueryState {
  const { data: liveEpisode, isLoading } = useQuery<IEpisode | null, Error>({
    queryKey: ['liveEpisode', contentId, isStation],
    // eslint-disable-next-line @tanstack/query/no-void-query-fn
    queryFn: () => fetchLiveEpisode({contentId, isStation}),
    enabled: Boolean(contentId),
    staleTime: RefreshTimes.every15s,
    refetchInterval: RefreshTimes.every15s,
  })

  return { liveEpisode, isLoading }
}
